import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Textarea } from '../../../components/ui/textarea';

export const HeroCard = ({ content, setContent, save, saving }) => {
  const setHero = (k) => (e) => setContent((c) => ({ ...c, hero: { ...c.hero, [k]: e.target.value } }));

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <h3 className="font-display font-semibold text-lg">Hero Section</h3>
      <p className="text-sm text-muted-foreground mt-1">Edits appear immediately on the homepage after saving.</p>
      <div className="mt-5 grid sm:grid-cols-2 gap-4">
        <div className="sm:col-span-2">
          <label className="text-sm font-medium">Eyebrow label</label>
          <Input value={content.hero.eyebrow} onChange={setHero('eyebrow')} className="h-10 mt-1.5" data-testid="admin-content-hero-eyebrow-input" />
        </div>
        <div>
          <label className="text-sm font-medium">Headline line 1</label>
          <Input value={content.hero.headline_1} onChange={setHero('headline_1')} className="h-10 mt-1.5" data-testid="admin-content-hero-headline1-input" />
        </div>
        <div>
          <label className="text-sm font-medium">Headline line 2</label>
          <Input value={content.hero.headline_2} onChange={setHero('headline_2')} className="h-10 mt-1.5" data-testid="admin-content-hero-headline2-input" />
        </div>
        <div className="sm:col-span-2">
          <label className="text-sm font-medium">Supporting statement</label>
          <Textarea value={content.hero.subtext} onChange={setHero('subtext')} className="mt-1.5 min-h-[70px]" data-testid="admin-content-hero-subtext-input" />
        </div>
        <div className="sm:col-span-2">
          <label className="text-sm font-medium">Benefit line</label>
          <Input value={content.hero.benefit_line} onChange={setHero('benefit_line')} className="h-10 mt-1.5" data-testid="admin-content-hero-benefit-input" />
        </div>
      </div>
      <Button className="h-10 mt-5" disabled={saving === 'hero'} onClick={() => save('hero')} data-testid="admin-content-hero-save-button">
        {saving === 'hero' ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
        Save Hero
      </Button>
    </div>
  );
};
